export const ERR_OK = 0


// WEBPACK FOOTER //
// ./src/api/config.js